module.exports = __webpack_public_path__ + "static/img/miagencia_movil.a26ee98a.svg";